import { defineMessages } from 'react-intl';

export const membershipTypeMessages = defineMessages({
    membershipTemplates: {
        id: 'membership-templates',
        defaultMessage: 'Membership templates',
    },
    membershipTemplate: {
        id: 'membership-template',
        defaultMessage: 'Membership template',
    },
    memberships: {
        id: 'memberships',
        defaultMessage: 'Memberships',
    },
    templates: {
        id: 'templates',
        defaultMessage: 'Templates',
    },
    template: {
        id: 'template',
        defaultMessage: 'Template',
    },
    custom: {
        id: 'custom',
        defaultMessage: 'Custom',
    },
    priced: {
        id: 'priced',
        defaultMessage: 'Priced',
    },
    createTemplateSuccess: {
        id: 'create-template-success',
        defaultMessage: 'Template created',
    },
    createTemplateSuccessDescription: {
        id: 'create-template-success-description',
        defaultMessage: 'A new membership template has been successfully created.',
    },
    addTemplateModalSubtitle: {
        id: 'add-template-modal-subtitle',
        defaultMessage: 'Add a new membership template',
    },
    hasPricingPlan: {
        id: 'has-pricing-plan',
        defaultMessage: 'Has pricing plan',
    },
    applyPricingPerSpace: {
        id: 'apply-pricing-per-space',
        defaultMessage: 'Apply pricing per space',
    },
    autoRenew: {
        id: 'auto-renew',
        defaultMessage: 'Auto renew',
    },
    limitDuration: {
        id: 'limit-duration',
        defaultMessage: 'Limit duration',
    },
    customDuration: {
        id: 'custom-duration',
        defaultMessage: 'Custom duration',
    },
    duration: {
        id: 'duration',
        defaultMessage: 'Duration',
    },
    durationUnit: {
        id: 'duration-unit',
        defaultMessage: 'Duration unit',
    },
    extraVisitors: {
        id: 'extra-visitors',
        defaultMessage: 'Extra visitors',
    },
    maxExtraVisitors: {
        id: 'max-extra-visitors',
        defaultMessage: 'Max extra visitors',
    },
    maxAllowedSpaces: {
        id: 'max-allowed-spaces',
        defaultMessage: 'Max allowed spaces',
    },
    customSpaceCount: {
        id: 'custom-space-count',
        defaultMessage: 'Custom space count',
    },
    limitSpaces: {
        id: 'limit-spaces',
        defaultMessage: 'Limit spaces',
    },
    allowAccessOverCapacityLimit: {
        id: 'allow-access-over-capacity-limit',
        defaultMessage: 'Allow access over capacity limit',
    },
    allowAccessAsClientOutsideRestrictions: {
        id: 'allow-access-as-client-outside-restrictions',
        defaultMessage: 'Allow access as client outside restrictions',
    },
    contributeToAvailableSpaces: {
        id: 'contribute-to-available-spaces',
        defaultMessage: 'Contribute to available spaces',
    },
    limitToRoles: {
        id: 'limit-to-roles',
        defaultMessage: 'Limit to roles',
    },
    templateDashboard: {
        id: 'template-dashboard',
        defaultMessage: '{template} dashboard',
    },
    membershipTemplateDashboard: {
        id: 'membership-template-dashboard',
        defaultMessage: 'Template dashboard',
    },
    activeTemplate: {
        id: 'active-template',
        defaultMessage: 'Active',
    },
    inactiveTemplate: {
        id: 'inactive-template',
        defaultMessage: 'Inactive',
    },
    activateTemplate: {
        id: 'activate-template',
        defaultMessage: 'Activate',
    },
    pricedPerSpace: {
        id: 'priced-per-space',
        defaultMessage: 'Priced per space',
    },
    allowCustomDuration: {
        id: 'allow-custom-duration',
        defaultMessage: 'Allow custom duration',
    },
    nameBg: {
        id: 'name-bg',
        defaultMessage: 'Name (BG)',
    },
    nameEn: {
        id: 'name-en',
        defaultMessage: 'Name (EN)',
    },
    descriptionBg: {
        id: 'description-bg',
        defaultMessage: 'Description (BG)',
    },
    descriptionEn: {
        id: 'description-en',
        defaultMessage: 'Description (EN)',
    },
    deleteTemplateSuccess: {
        id: 'delete-template-success',
        defaultMessage: 'Template deleted',
    },
    deleteTemplateSuccessDescription: {
        id: 'delete-template-success-description',
        defaultMessage: 'Template {entry} has been successfully deleted.',
    },
    deleteTemplate: {
        id: 'delete-template',
        defaultMessage: 'Delete template',
    },
    deleteTemplateSubtitle: {
        id: 'delete-template-subtitle',
        defaultMessage: 'Permanently delete template {entry}',
    },
    confirmDeleteTemplate: {
        id: 'confirm-delete-template',
        defaultMessage: 'Are you sure you want to delete template {entry}? This action cannot be undone.',
    },
    activateTemplateModal: {
        id: 'activate-template-modal',
        defaultMessage: 'Activate template',
    },
    activateTemplateSubtitle: {
        id: 'activate-template-subtitle',
        defaultMessage: 'Activate template {entry}',
    },
    activatedTemplateSuccess: {
        id: 'activated-template-success',
        defaultMessage: 'Template activated',
    },
    activatedTemplateSuccessDescription: {
        id: 'activated-template-success-description',
        defaultMessage: 'Template {entry} has been successfully activated.',
    },
    confirmActivateTemplate: {
        id: 'confirm-activate-template',
        defaultMessage: 'Are you sure you want to activate template {entry}?',
    },
    editTemplate: {
        id: 'edit-template',
        defaultMessage: 'Edit template',
    },
    editTemplateSubtitle: {
        id: 'edit-template-subtitle',
        defaultMessage: 'Edit template {entry}',
    },
    updateTemplateSuccess: {
        id: 'update-template-success',
        defaultMessage: 'Template updated',
    },
    updateTemplateSuccessDescription: {
        id: 'update-template-success-description',
        defaultMessage:
            'Template {entry} has been successfully updated. The changes apply to memberships, and active stays may be re-evaluated.',
    },
    timeRestriction: {
        id: 'time-restriction',
        defaultMessage: 'Time restriction',
    },
    timeRestrictionDescription: {
        id: 'time-restriction-description',
        defaultMessage: 'The restrictions are configured in the dashboard for every zone and time',
    },
    typeCreatedAt: {
        id: 'type-created-at',
        defaultMessage: 'Created at',
    },
    typeModifiedAt: {
        id: 'type-modified-at',
        defaultMessage: 'Modified at',
    },
    deactivateTemplate: {
        id: 'deactivate-template',
        defaultMessage: 'Deactivate',
    },
    deactivateTemplateModal: {
        id: 'deactivate-template-modal',
        defaultMessage: 'Deactivate template',
    },
    deactivateTemplateSubtitle: {
        id: 'deactivate-template-subtitle',
        defaultMessage: 'Deactivate template {entry}',
    },
    deactivatedTemplateSuccess: {
        id: 'deactivated-template-success',
        defaultMessage: 'Template deactivated',
    },
    deactivatedTemplateSuccessDescription: {
        id: 'deactivated-template-success-description',
        defaultMessage: 'Template {entry} has been successfully deactivated.',
    },
    confirmDeactivateTemplate: {
        id: 'confirm-deactivate-template',
        defaultMessage: 'Are you sure you want to deactivate template {entry}?',
    },
    isSystem: {
        id: 'is-system',
        defaultMessage: 'System',
    },
    copyMembershipTemplateSubtitle: {
        id: 'copy-membership-template-subtitle',
        defaultMessage: 'Copy membership template {entry}',
    },
    copyMembershipTemplateSuccess: {
        id: 'copy-membership-template-success',
        defaultMessage: 'Membership template copied',
    },
    copyMembershipTemplateSuccessDescription: {
        id: 'copy-membership-template-success-description',
        defaultMessage: 'Membership template {entry} has been successfully copied.',
    },
    requiredRecords: {
        id: 'required-records',
        defaultMessage: '{count} of {totalCount} required records',
    },
    requiredRecordsToResolve: {
        id: 'required-records-to-resolve',
        defaultMessage:
            '{count, plural, =0 {# items} one {# item} other {# items}} to resolve before it works as intended.',
    },
    notConfiguredProperly: {
        id: 'not-configured-properly',
        defaultMessage: 'This template is not configured properly',
    },
    fullyConfigured: {
        id: 'fully-configured',
        defaultMessage: 'This template is fully configured',
    },
    fullyConfiguredDescription: {
        id: 'fully-configured-description',
        defaultMessage: 'All required records are in place.',
    },
    required: {
        id: 'required',
        defaultMessage: 'Required',
    },
    optional: {
        id: 'optional',
        defaultMessage: 'Optional',
    },
    configure: {
        id: 'configure',
        defaultMessage: 'Configure',
    },
    totalAllowedTimes: {
        id: 'total-allowed-times',
        defaultMessage: '{count} time windows',
    },
    pluralRules: {
        id: 'plural-rules',
        defaultMessage: '{value, plural, =0 {# rules} one {# rule} other {# rules}}',
    },
    zoneRulesSpaces: {
        id: 'zone-rules-spaces',
        defaultMessage: '{value} spaces',
    },
    allGatewaysAllowed: {
        id: 'all-gateways-allowed',
        defaultMessage: 'All gateways allowed',
    },
    restrictedGatewaysCount: {
        id: 'restricted-gateways-count',
        defaultMessage: '{count} restricted gateways',
    },
    pluralRestrictedGatewaysCount: {
        id: 'plural-restricted-gateways-count',
        defaultMessage:
            '{value, plural, =0 {# restricted gateways} one {# restricted gateway} other {# restricted gateways}}',
    },
    pricingPlanRequirement: {
        id: 'pricing-plan-requirement',
        defaultMessage: 'The plan used to charge members for their stays.',
    },
    allowedTimesRequirement: {
        id: 'allowed-times-requirement',
        defaultMessage:
            'Days and hours the membership is valid. With none, the membership is never valid and entry is refused.',
    },
    restrictedGatewaysRequirement: {
        id: 'restricted-gateways-requirement',
        defaultMessage: 'Optional. Restrict entry to specific barriers, each with its own pricing plan.',
    },
    zoneRulesRequirement: {
        id: 'zone-rules-requirement',
        defaultMessage:
            'Which zones members can enter and how many spaces each reserves. Reserved spaces must total the max allowed spaces ({count}).',
    },
    zoneRulesRequirementCustomSpace: {
        id: 'zone-rules-requirement-custom-space',
        defaultMessage:
            'Not defined here - because "Custom space count" is on, each membership sets its own zones and per-zone space limits.',
    },
    setPerMembership: {
        id: 'set-per-membership',
        defaultMessage: 'Set per membership',
    },
    noLimits: {
        id: 'no-limits',
        defaultMessage: 'No limits',
    },
    activeMembershipTypeProtectedError: {
        id: 'custom-error:active_membership_type_protected',
        defaultMessage: 'Active membership types and their related entities cannot be modified or deleted!',
    },
    nonDeletableMembershipTypeError: {
        id: 'custom-error:non_deletable_membership_type',
        defaultMessage:
            'The membership template cannot be deleted as this will affect linked memberships and their history!',
    },
    customTimeRestriction: {
        id: 'custom-time-restriction',
        defaultMessage: 'Custom time restriction',
    },
    allowedTimesRequirementOptional: {
        id: 'allowed-times-requirement-optional',
        defaultMessage: 'Days and hours the membership is valid.',
    },
    basics: {
        id: 'basics',
        defaultMessage: 'Basics',
    },
    access: {
        id: 'access',
        defaultMessage: 'Access',
    },
    price: {
        id: 'price',
        defaultMessage: 'Price',
    },
    validity: {
        id: 'validity',
        defaultMessage: 'Validity',
    },
    continue: {
        id: 'continue',
        defaultMessage: 'Continue',
    },
    spaces: {
        id: 'spaces',
        defaultMessage: 'Spaces',
    },
    allowedEntryExitTime: {
        id: 'allowed-entry-exit-time',
        defaultMessage: 'Allowed entry and exit time',
    },
    others: {
        id: 'others',
        defaultMessage: 'Others',
    },
    overview: {
        id: 'overview',
        defaultMessage: 'Overview',
    },
    roles: {
        id: 'roles',
        defaultMessage: 'Roles',
    },
    stepDescription: {
        id: 'step-description',
        defaultMessage: 'Step {currentStep} of {lastStep} - {label}',
    },
    subscriptionTypeDescription: {
        id: 'subscription-type-description',
        defaultMessage: 'Available only when the template has a pricing plan and the type is set to subscription',
    },
    basicsBody: {
        id: 'membership-template-basics-body',
        defaultMessage:
            'Name the template and choose its type and site. Every membership created from this template copies its rules. The names appear in the manager, in the event log and on the entry and exit displays.',
    },
    basicsTip: {
        id: 'membership-template-basics-tip',
        defaultMessage:
            'The type matters in later steps. Subscription is the only type that can use per-space pricing and auto-renew, and it needs a pricing plan. Custom always takes its allowed hours from each membership.',
    },
    nameDescription: {
        id: 'membership-template-name-description',
        defaultMessage: 'Shown in {language} in the manager and on displays.',
    },
    nameTooltip: {
        id: 'membership-template-name-tooltip',
        defaultMessage: 'Required in every language. Use a name operators will recognise, e.g. “Employees – Level -1”.',
    },
    descriptionDescription: {
        id: 'membership-template-description-description',
        defaultMessage: 'Optional. A short note on who this template is for.',
    },
    typeDescription: {
        id: 'membership-template-type-description',
        defaultMessage: 'Groups the memberships and decides some of the rules.',
    },
    typeTooltip: {
        id: 'membership-template-type-tooltip',
        defaultMessage:
            'The memberships list has one tab per type, and a zone’s capacity limit for a type applies to it. Subscription: sold at the pay station and needs a pricing plan and a duration. Custom: allowed days and hours are always set on each membership. Subscription and Reservation memberships can’t be converted to another template.',
    },
    siteDescription: {
        id: 'membership-template-site-description',
        defaultMessage: 'The zones and gateways in the rules come from this site.',
    },
    siteTooltip: {
        id: 'membership-template-site-tooltip',
        defaultMessage:
            'The zone rules and restricted gateways you add later on the template dashboard can only use this site’s zones and gateways.',
    },
    accessBody: {
        id: 'membership-template-access-body',
        defaultMessage:
            'Set how many vehicles one membership can have inside at the same time, when it may enter, and what happens when the zone is full. The per-zone details and the allowed hours are added later, on the template dashboard.',
    },
    accessTip: {
        id: 'membership-template-access-tip',
        defaultMessage:
            'These switches change what the barrier does. A change to the template’s zone rules reaches every existing membership of this template straight away.',
    },
    limitSpacesDescription: {
        id: 'membership-template-limit-spaces-description',
        defaultMessage: 'Cap how many of a membership’s vehicles can be inside at once.',
    },
    limitSpacesTooltip: {
        id: 'membership-template-limit-spaces-tooltip',
        defaultMessage:
            'On: a membership can have at most Max allowed spaces vehicles inside at the same time, across all zones. To activate the template, add zone rules on the dashboard whose allowed spaces add up to at least that number. Off: there is no cap, only the zone’s capacity.',
    },
    customSpaceCountDescription: {
        id: 'membership-template-custom-space-count-description',
        defaultMessage: 'Set the number of spaces and the zone rules on each membership.',
    },
    customSpaceCountTooltip: {
        id: 'membership-template-custom-space-count-tooltip',
        defaultMessage:
            'On: Max allowed spaces stays empty here and must be filled in when each membership is created, and the zone rules are set on each membership instead of the template. Use it when holders get different numbers of spaces.',
    },
    extraVisitorsDescription: {
        id: 'membership-template-extra-visitors-description',
        defaultMessage: 'Let members bring more vehicles than their spaces in a zone.',
    },
    extraVisitorsTooltip: {
        id: 'membership-template-extra-visitors-tooltip',
        defaultMessage:
            'On: a membership can have more vehicles in a zone than that zone’s allowed spaces, up to the extra visitors set in the zone rule and never more than Max extra visitors. Extra vehicles still need a free space, and the overall Max allowed spaces still applies. The zone rule also sets how long an extra visitor can stay.',
    },
    maxAllowedSpacesDescription: {
        id: 'membership-template-max-allowed-spaces-description',
        defaultMessage: 'Vehicles allowed inside at the same time, across all zones.',
    },
    maxAllowedSpacesTooltip: {
        id: 'membership-template-max-allowed-spaces-tooltip',
        defaultMessage:
            'Copied to every membership of this template. Once a membership has this many vehicles inside, the next one is refused, or enters as a client if “Allow access as client outside restrictions” is on.',
    },
    maxExtraVisitorsDescription: {
        id: 'membership-template-max-extra-visitors-description',
        defaultMessage: 'Top limit for extra visitors in any zone rule.',
    },
    maxExtraVisitorsTooltip: {
        id: 'membership-template-max-extra-visitors-tooltip',
        defaultMessage:
            'A zone rule can allow fewer extra visitors than this, never more. A higher number in a zone rule is cut down to this one.',
    },
    timeRestrictionAccessDescription: {
        id: 'membership-template-time-restriction-description',
        defaultMessage: 'Members can enter only on the allowed days and hours.',
    },
    timeRestrictionAccessTooltip: {
        id: 'membership-template-time-restriction-tooltip',
        defaultMessage:
            'On: add the allowed days and hours on the template dashboard. Outside them, entry is refused. The template can’t be activated until it has at least one time window, unless Custom time restriction is on.',
    },
    customTimeRestrictionDescription: {
        id: 'membership-template-custom-time-restriction-description',
        defaultMessage: 'Allowed days and hours are set on each membership.',
    },
    customTimeRestrictionTooltip: {
        id: 'membership-template-custom-time-restriction-tooltip',
        defaultMessage:
            'On: the template needs no time windows. Each membership gets its own days and hours on its dashboard, and until they are added it can’t enter. Custom-type templates always work this way.',
    },
    allowAccessOverCapacityLimitDescription: {
        id: 'membership-template-allow-access-over-capacity-limit-description',
        defaultMessage: 'Members can enter even when the zone is full.',
    },
    allowAccessOverCapacityLimitTooltip: {
        id: 'membership-template-allow-access-over-capacity-limit-tooltip',
        defaultMessage:
            'On: the zone’s free spaces and its capacity limit for this type are not checked for these members. The membership’s own space limits still apply. Reserved spaces always get in, whatever this switch says. It has no effect in zones that don’t limit access by capacity.',
    },
    allowAccessAsClientOutsideRestrictionsDescription: {
        id: 'membership-template-allow-access-as-client-outside-restrictions-description',
        defaultMessage:
            'A member who would be refused entry because of space or time restrictions can still enter as a regular client.',
    },
    allowAccessAsClientOutsideRestrictionsTooltip: {
        id: 'membership-template-allow-access-as-client-outside-restrictions-tooltip',
        defaultMessage:
            'On: when the membership’s rules would refuse entry (outside the allowed hours, at a restricted gateway, all spaces in use, zone full), the vehicle goes through the normal client checks instead. The stay is then charged at the parking’s usual tariff. Off: the barrier stays closed.',
    },
    contributeToAvailableSpacesDescription: {
        id: 'membership-template-contribute-to-available-spaces-description',
        defaultMessage: 'Members’ vehicles lower the zone’s free spaces.',
    },
    contributeToAvailableSpacesTooltip: {
        id: 'membership-template-contribute-to-available-spaces-tooltip',
        defaultMessage:
            'On: members’ vehicles in a zone, and their reserved spaces even when empty, lower the free spaces that are shown and checked at the barrier. Off: members don’t change the zone’s free-space count. Use it for vehicles that don’t take a public space, such as service vehicles.',
    },
    priceBody: {
        id: 'membership-template-price-body',
        defaultMessage:
            'Choose whether members pay for their stays and which pricing plan applies. The subscription settings work only when the type is Subscription.',
    },
    priceTip: {
        id: 'membership-template-price-tip',
        defaultMessage:
            'Without a pricing plan, members’ stays are not charged. A member who enters as a client (see Access) pays the parking’s usual tariff for that stay.',
    },
    hasPricingPlanDescription: {
        id: 'membership-template-has-pricing-plan-description',
        defaultMessage: 'Charge members for their stays with a dedicated plan.',
    },
    hasPricingPlanTooltip: {
        id: 'membership-template-has-pricing-plan-tooltip',
        defaultMessage:
            'On: members’ stays are priced with the chosen plan instead of the gateway, zone or site tariff. Off: their stays are not charged. The template can’t be activated until the plan has a published version that is valid today.',
    },
    pricingPlanDescription: {
        id: 'membership-template-pricing-plan-description',
        defaultMessage: 'The plan used for members’ stays and for subscription sales.',
    },
    pricingPlanTooltip: {
        id: 'membership-template-pricing-plan-tooltip',
        defaultMessage:
            'The plan’s currently published version applies, so a new version takes effect without editing the template. For Subscription, the plan must be fixed-price, and that price is the cost of one period.',
    },
    applyPricingPerSpaceDescription: {
        id: 'membership-template-apply-pricing-per-space-description',
        defaultMessage: 'Multiply the subscription price by the number of spaces.',
    },
    applyPricingPerSpaceTooltip: {
        id: 'membership-template-apply-pricing-per-space-tooltip',
        defaultMessage:
            'Subscription only. On: 3 spaces cost 3 × the plan price per period. Off: the price is the same however many spaces are bought.',
    },
    autoRenewDescription: {
        id: 'membership-template-auto-renew-description',
        defaultMessage: 'Renew the subscription automatically when it ends.',
    },
    autoRenewTooltip: {
        id: 'membership-template-auto-renew-tooltip',
        defaultMessage: 'Subscription only. On: when a period ends, the next one starts and is charged automatically.',
    },
    validityBody: {
        id: 'membership-template-validity-body',
        defaultMessage: 'Set how long each membership lasts and which users can issue memberships from this template.',
    },
    validityTip: {
        id: 'membership-template-validity-tip',
        defaultMessage:
            'The end date is set when a membership is created. Changing the duration later only affects new memberships.',
    },
    limitDurationDescription: {
        id: 'membership-template-limit-duration-description',
        defaultMessage: 'Memberships get an end date.',
    },
    limitDurationTooltip: {
        id: 'membership-template-limit-duration-tooltip',
        defaultMessage:
            'On: each membership ends after the set duration, or on its own end date if Custom duration is on. Off: memberships have no end date and stay valid until someone ends them. Subscription templates need this on.',
    },
    customDurationDescription: {
        id: 'membership-template-custom-duration-description',
        defaultMessage: 'Set the end date on each membership.',
    },
    customDurationTooltip: {
        id: 'membership-template-custom-duration-tooltip',
        defaultMessage:
            'On: the template has no fixed length. The operator enters the end date when creating each membership.',
    },
    durationDescription: {
        id: 'membership-template-duration-description',
        defaultMessage: 'How long one membership lasts.',
    },
    durationTooltip: {
        id: 'membership-template-duration-tooltip',
        defaultMessage:
            'End date = start date + this length. For Subscription it is one paid period, so buying 3 periods of 1 month gives 3 months.',
    },
    durationUnitDescription: {
        id: 'membership-template-duration-unit-description',
        defaultMessage: 'Hours, days, weeks, months or years.',
    },
    limitToRolesDescription: {
        id: 'membership-template-limit-to-roles-description',
        defaultMessage: 'Leave empty to let every role use this template.',
    },
    limitToRolesTooltip: {
        id: 'membership-template-limit-to-roles-tooltip',
        defaultMessage:
            'Only users with one of these roles can create memberships from this template. Everyone else gets an error when they try.',
    },
    overviewBody: {
        id: 'membership-template-overview-body',
        defaultMessage: 'Check the settings before you create the template. Click any step above to change it.',
    },
    overviewWhatHappensNext: {
        id: 'membership-template-overview-what-happens-next',
        defaultMessage:
            '<b>What happens next.</b> The template is created as <b>inactive</b> and opens on its dashboard. Add what it still needs there: zone rules, allowed times, restricted gateways or a published pricing plan. A banner lists exactly what is missing. Once everything is in place, activate it so memberships can be created from it.',
    },
    lockedFieldError: {
        id: 'locked-field-error',
        defaultMessage: 'The field cannot be updated as this will affect linked memberships and their history!',
    },
});

export const restrictedGatewayMessages = defineMessages({
    gateway: {
        id: 'gateway',
        defaultMessage: 'Gateway',
    },
    gatewayPoint: {
        id: 'gateway-point',
        defaultMessage: 'Gateway',
    },
    gateways: {
        id: 'gateways',
        defaultMessage: 'Gateways',
    },
    restrictedGateway: {
        id: 'restricted-gateway',
        defaultMessage: 'Restricted gateway',
    },
    restrictedGateways: {
        id: 'restricted-gateways',
        defaultMessage: 'Restricted gateways',
    },
    entryZone: {
        id: 'entry-zone',
        defaultMessage: 'Entry zone',
    },
    exitZone: {
        id: 'exit-zone',
        defaultMessage: 'Exit zone',
    },
    addRestrictedGatewayModalSubtitle: {
        id: 'add-restricted-gateway-modal-subtitle',
        defaultMessage: 'Add a new restricted gateway',
    },
    createRestrictedGatewaySuccess: {
        id: 'create-restricted-gateway-success',
        defaultMessage: 'Restricted gateway created',
    },
    createRestrictedGatewaySuccessDescription: {
        id: 'create-restricted-gateway-success-description',
        defaultMessage:
            'Restricted gateway has been successfully created. The changes apply to memberships, and active stays may be re-evaluated.',
    },
    deleteRestrictedGateway: {
        id: 'delete-restricted-gateway',
        defaultMessage: 'Delete restricted gateway',
    },
    deleteRestrictedGatewaySubtitle: {
        id: 'delete-restricted-gateway-subtitle',
        defaultMessage: 'Permanently delete restricted gateway {entry}',
    },
    confirmDeleteRestrictedGateway: {
        id: 'confirm-delete-restricted-gateway',
        defaultMessage: 'Are you sure you want to delete restricted gateway {entry}? This action cannot be undone.',
    },
    deleteRestrictedGatewaySuccess: {
        id: 'delete-restricted-gateway-success',
        defaultMessage: 'Restricted gateway deleted',
    },
    deleteRestrictedGatewaySuccessDescription: {
        id: 'delete-restricted-gateway-success-description',
        defaultMessage:
            'Restricted gateway {entry} has been successfully deleted. The changes apply to memberships, and active stays may be re-evaluated.',
    },
    inheritedRestrictedGateways: {
        id: 'inherited-restricted-gateways',
        defaultMessage: 'Restricted gateways - inherited from {entry}',
    },
});

export const zoneRulesMessages = defineMessages({
    zoneRules: {
        id: 'zone-rules',
        defaultMessage: 'Zone rules',
    },
    zoneRule: {
        id: 'zone-rule',
        defaultMessage: 'Rule',
    },
    rules: {
        id: 'rules',
        defaultMessage: 'Rules',
    },
    rule: {
        id: 'rule',
        defaultMessage: 'Rule',
    },
    transitTime: {
        id: 'transit-time',
        defaultMessage: 'Transit time',
    },
    transitTimeInMinutes: {
        id: 'transit-time-in-minutes',
        defaultMessage: 'Transit time in minutes',
    },
    reserveSpaces: {
        id: 'reserve-spaces',
        defaultMessage: 'Reserve spaces',
    },
    createZoneRuleSuccess: {
        id: 'create-zone-rule-success',
        defaultMessage: 'Zone rule created',
    },
    createZoneRuleSuccessDescription: {
        id: 'create-zone-rule-success-description',
        defaultMessage:
            'A new zone rule has been successfully created. The changes apply to memberships, and active stays may be re-evaluated.',
    },
    addZoneRuleModalSubtitle: {
        id: 'add-zone-rule-modal-subtitle',
        defaultMessage: 'Add a new zone rule',
    },
    allowedExtraVisitorsTime: {
        id: 'allowed-extra-visitors-time',
        defaultMessage: 'Allowed extra visitors time',
    },
    allowedExtraVisitorsTimeInMinutes: {
        id: 'allowed-extra-visitors-time-in-minutes',
        defaultMessage: 'Allowed extra visitors time in minutes',
    },
    allowedSpacesCount: {
        id: 'allowed-spaces-count',
        defaultMessage: 'Allowed spaces',
    },
    deleteZoneRuleSuccessDescription: {
        id: 'delete-zone-rule-success-description',
        defaultMessage:
            'Zone rule for {entry} has been successfully deleted. The changes apply to memberships, and active stays may be re-evaluated.',
    },
    deleteZoneRule: {
        id: 'delete-zone-rule',
        defaultMessage: 'Delete zone rule',
    },
    deleteZoneRuleSubtitle: {
        id: 'delete-zone-rule-subtitle',
        defaultMessage: 'Permanently delete zone rule for {entry}',
    },
    confirmDeleteZoneRule: {
        id: 'confirm-delete-zone-rule',
        defaultMessage: 'Are you sure you want to delete zone rule for {entry}? This action cannot be undone.',
    },
    deleteZoneRuleSuccess: {
        id: 'delete-zone-rile-success',
        defaultMessage: 'Zone rule deleted',
    },
    updateZoneRuleSuccess: {
        id: 'update-zone-rule-success',
        defaultMessage: 'Zone rule updated',
    },
    updateZoneRuleSuccessDescription: {
        id: 'update-zone-rule-success-description',
        defaultMessage:
            'Rule for {entry} has been successfully updated. The changes apply to memberships, and active stays may be re-evaluated.',
    },
    editZoneRuleSubtitle: {
        id: 'edit-zone-rule-subtitle',
        defaultMessage: 'Edit rule for {entry}',
    },
    zoneRulesCanNotBeDefined: {
        id: 'zone-rules-can-not-be-defined',
        defaultMessage: 'Zone rules can not be defined in this template',
    },
    zoneRulesCanNotBeDefinedSubtitle: {
        id: 'zone-rules-can-not-be-defined-subtitle',
        defaultMessage:
            'You have selected "Custom space count" to be Yes, and therefore the rules for each zone are to be individually defined in each membership.',
    },
    inheritedZoneRules: {
        id: 'inherited-zone-rules',
        defaultMessage: 'Zone rules - inherited from {entry}',
    },
});
